module.exports = __webpack_public_path__ + "img/35.323ace1c.jpg";